import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import { Link, Typography } from '@mui/material';
import { palette } from '../../../theme';
import { OpenDesignAppTourBtn, GetADomainBtn } from './GetADomainBtn';
import { SubTitle } from '../../common';
import Links from '../../../constants/links';

const DomainSetupPreview = ({ isDesktop }) => (
  <Box
    display="flex"
    flex={1}
    pb={3}
    pt={{ xs: 3, md: 0 }}
    pl={{ xs: 0, md: 3 }}
    sx={
      isDesktop
        ? { borderLeft: `1px solid ${palette.primary.main}` }
        : { borderTop: `1px solid ${palette.primary.main}` }
    }
  >
    <Card
      sx={{
        width: '100%',
        bgcolor: palette.cardBg,
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <SubTitle homeHeader style={{ textAlign: 'left' }} mb={2}>
          Let&apos;s get your domain set up!
        </SubTitle>
        <Typography variant="body2" align="center">
          You can get a domain <strong>free for 1 year</strong> or connect one you already own.
          <br />
          <Link href={Links.IONOS_DOMAIN_PURCHASE_URL} target="_blank" rel="noopener noreferrer">
            Learn More
          </Link>
        </Typography>
        <Box display="flex" gap={2} flexDirection="column" width="100%">
          <GetADomainBtn />
          <OpenDesignAppTourBtn />
        </Box>
      </Box>
    </Card>
  </Box>
);

DomainSetupPreview.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
};

export default DomainSetupPreview;
